import React, { useState } from 'react'
import { PoseGroup } from 'react-pose'
import { StyledExpansionPanel, StyledExpansionPanelSummary, StyledExpansionPanelDetailsWrapper, StyledExpansionPanelDetails, StyledTitle, StyledIcon } from './styled'

const ExpansionPanel = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false)

    const handleClickSummary = () => setIsOpen(!isOpen)

    return (
        <StyledExpansionPanel>
            <StyledExpansionPanelSummary isOpen={isOpen} onClick={handleClickSummary}>
                <StyledTitle>
                    {title}
                </StyledTitle>
                <StyledIcon isOpen={isOpen} />
            </StyledExpansionPanelSummary>
            <PoseGroup>
                {
                    isOpen &&
                    <StyledExpansionPanelDetailsWrapper key='expansion-panel' isOpen={isOpen}>
                        <StyledExpansionPanelDetails>
                            {children}
                        </StyledExpansionPanelDetails>
                    </StyledExpansionPanelDetailsWrapper>
                }

            </PoseGroup>
        </StyledExpansionPanel>
    )
}

export default ExpansionPanel
